<template>
  <section class="ods-padding-top-11">
    <h2
      class="ods-text--size-india ods-text--weight-medium ods-margin-top-0 ods-margin-bottom-5 ods-text--size-golf-breakpoint-medium"
    >
      {{ $t('avfallOgGjenvinning.minebeholdere.title') }}
    </h2>
    <div v-if="renovasjonsbeholdereLaster">
      <ods-spinner />
      {{ $t('avfallOgGjenvinning.loading') }}
    </div>
    <ods-status-message
      v-else-if="renovasjonsbeholdereFeiler"
      class="mb-size-20"
      tittel="Melding om advarsel"
      :melding="$t('avfallOgGjenvinning.minebeholdere.error')"
      meldingstype="warning"
    />
    <ul v-else-if="renovasjonsbeholdere.length > 0" class="ods-grid ods-grid--gap">
      <li
        v-for="(beholder, index) in renovasjonsbeholdere"
        :key="index"
        class="ods-grid__column--12 ods-grid__column--4-breakpoint-medium"
      >
        <h4 class="ods-text--weight-medium ods-margin-bottom-2 ods-text--size-juliett-breakpoint-medium">
          <span class="inline-icon inline-icon--small mr-size-5">
            <ods-waste-container
              class="ods-icon ods-icon--align-right oods-icon--size-hotel ods-text--weight-medium"
              aria-hidden="true"
            />
          </span>
          {{ beholder.beskrivelse }}
        </h4>
        <p class="mb-size-0 ods-margin-bottom-0">
          {{
            $t('avfallOgGjenvinning.minebeholdere.beholderinfo', {
              antall: beholder.antallBeholdere,
              liter: beholder.volum,
              hyppighet: beholder.hyppighet,
            })
          }}
        </p>
        <p class="mb-size-0">
          <template v-if="beholder.tommeDato">
            {{
              $t('avfallOgGjenvinning.minebeholdere.nesteTomming', {
                dato: $minside.formatDateShort(beholder.tommeDato),
              })
            }}
          </template>
          <template v-else>
            {{ $t('avfallOgGjenvinning.minebeholdere.nesteTommingErTom') }}
          </template>
        </p>
      </li>
    </ul>
    <div v-else class="ok-alert ok-alert--warning">
      {{ $t('avfallOgGjenvinning.minebeholdere.empty') }}
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import OdsSpinner from '@/global-components/OdsSpinner.vue';
import OdsStatusMessage from '../global-components/OdsStatusMessage.vue';
import OdsWasteContainer from '../global-components/OdsWasteContainer.vue';

export default {
  name: 'MineBeholdere',
  components: {
    OdsSpinner,
    OdsStatusMessage,
    OdsWasteContainer,
  },
  computed: {
    ...mapState('eiendommer', ['eiendommer', 'eiendommerLoading']),
    ...mapState('avfallOgGjenvinning', [
      'renovasjonsbeholdere',
      'renovasjonsbeholdereLaster',
      'renovasjonsbeholdereFeiler',
    ]),
  },
};
</script>
